function cov_2aqzpb9g1t() {
  var path = "/app/src/utils/get-locale.ts";
  var hash = "9ed46db1dd2c1937b721acaea2338b503efbeb79";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/get-locale.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 22
        },
        end: {
          line: 6,
          column: 1
        }
      },
      "1": {
        start: {
          line: 8,
          column: 25
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "2": {
        start: {
          line: 9,
          column: 19
        },
        end: {
          line: 9,
          column: 45
        }
      },
      "3": {
        start: {
          line: 10,
          column: 21
        },
        end: {
          line: 10,
          column: 60
        }
      },
      "4": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 25
          },
          end: {
            line: 8,
            column: 26
          }
        },
        loc: {
          start: {
            line: 8,
            column: 66
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 19
          },
          end: {
            line: 9,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 19
          },
          end: {
            line: 9,
            column: 25
          }
        }, {
          start: {
            line: 9,
            column: 29
          },
          end: {
            line: 9,
            column: 45
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 10,
            column: 21
          },
          end: {
            line: 10,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 10,
            column: 32
          },
          end: {
            line: 10,
            column: 38
          }
        }, {
          start: {
            line: 10,
            column: 41
          },
          end: {
            line: 10,
            column: 60
          }
        }],
        line: 10
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9ed46db1dd2c1937b721acaea2338b503efbeb79"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2aqzpb9g1t = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2aqzpb9g1t();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Lang, Locale } from 'src/types/lang-locale-type';
var defaultLocale = (cov_2aqzpb9g1t().s[0]++, _defineProperty(_defineProperty({}, Lang.en, Locale['en-US']), Lang.ar, Locale['ar-AE']));
cov_2aqzpb9g1t().s[1]++;
export var getLocale = function getLocale(lang, locale) {
  cov_2aqzpb9g1t().f[0]++;
  var isLocale = (cov_2aqzpb9g1t().s[2]++, (cov_2aqzpb9g1t().b[0][0]++, locale) && (cov_2aqzpb9g1t().b[0][1]++, locale in Locale));
  var localeCode = (cov_2aqzpb9g1t().s[3]++, isLocale ? (cov_2aqzpb9g1t().b[1][0]++, locale) : (cov_2aqzpb9g1t().b[1][1]++, defaultLocale[lang]));
  cov_2aqzpb9g1t().s[4]++;
  return localeCode;
};